/*
* 予約ボタンコンポーネント
*/
<template>
	<div class="reserve-button" v-if="$store.getters.enabledContents.reserve">
		<router-link :to="{ name: 'reserve-page', params: {} }">ご予約</router-link>
	</div>
</template>

<script>
export default {
	name: "reserveButton",
	props: {
		toppos: {}
	},
	mounted() {
		this.$nextTick(function(){
			if (this.toppos) {
				if (Object.prototype.toString.call(this.$el) == "[object HTMLDivElement]") {
					this.$el.classList.add('reserveBtn-toppos');
				}
			}
		});
	}
}
</script>

<style lang="less" scoped>
@import '../../less/reset.less';
@import '../../less/default.less';
@import '../../less/const.less';
.reserve-button {
	position: fixed;
	bottom: 8px;
	right :8px;
	width: 62px;
	height: 62px;
	border-radius: 50%;
	font-size: 1.4rem;
	font-weight: bold;
	background-color: #fe83cc;
	text-align: center;
	line-height: 62px;
	vertical-align: middle;
	z-index: 999;
}

.reserveBtn-toppos {
	bottom: 168px;
}

@media(max-width:570px) and (max-height:340px) {
	.reserveBtn-toppos {
		bottom: 128px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/template/reserveButton.vue